import store from "@/core/services/store";
import baseModuleUnit, {
    BASE_URL,
    ITEMS_ALL,
    MODULE_NAME as UNIT_MODULE_NAME,
    SET_ITEMS_ALL,
    GET_ITEMS_ALL
} from "@/core/services/store/unit/unit.module";

const _MODULE_NAME_UNIT = UNIT_MODULE_NAME;

export default {
    beforeCreate() {
        function registerStoreModule(moduleName, storeModule) {
            if (!(store && store.state && store.state[moduleName])) {
                store.registerModule(moduleName, storeModule)
            }
        }

        registerStoreModule(_MODULE_NAME_UNIT, baseModuleUnit)
    },
    data() {
        return {};
    },
    computed: {
        unitAllItems() {
            return store.getters[_MODULE_NAME_UNIT + '/' + ITEMS_ALL];
        },
        filters() {
            return {}
        }
    },
    methods: {
        getUnitAllItems(){
            this.$store.dispatch(_MODULE_NAME_UNIT + '/' + GET_ITEMS_ALL, {
                filters: this.filters,
                url: BASE_URL
            })
        },
    },
    mounted() {
        if (!this.unitAllItems || this.unitAllItems.length  < 0 ) {
            this.$store.commit(_MODULE_NAME_UNIT + '/' + SET_ITEMS_ALL, null);
            this.getUnitAllItems();
        }
    }
};
